import React, { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { ISelectOption } from '../../../../types/IClassifier'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import FormModal from '../../../../shared/components/FormModal'

interface FinlandCustomsRequestReplyProps {
  show: boolean
  onClose: () => void
  onSubmit: (data: {
    isAccepted: boolean
    notificationDescription: string
  }) => void
  isSubmitting: boolean
  isError: boolean
}

interface FinlandCustomsReplyFormValues {
  response: boolean | null
  description: string
}

function FinlandCustomsRequestReplyModal({
  show,
  onClose,
  onSubmit,
  isSubmitting,
  isError,
}: Readonly<FinlandCustomsRequestReplyProps>) {
  const { t } = useTranslation()

  const [form, setForm] = useState<FinlandCustomsReplyFormValues>({
    response: null,
    description: '',
  })

  const responseSelectOptions: ISelectOption[] = [
    {
      value: true,
      label: 'I Agree with Decision',
    },
    {
      value: false,
      label: 'I Disagree with Decision',
    },
  ]

  const submitForm = () => {
    if (form.response === null) return
    onSubmit({
      isAccepted: form.response,
      notificationDescription: form.description,
    })
  }

  useEffect(() => {
    if (isError) {
      toast.error('Error occurred when sending Finland customs response')
    }
  }, [isError])

  return (
    <FormModal show={show} title={t('declaration.p5.finlandCustomsRequestResponse')} onClose={onClose}>
      <div className="d-flex flex-column align-self-center w-100">
        <Select
          placeholder={t('declaration.p5.agreeWithCustoms')}
          options={responseSelectOptions}
          className="select w-100 mb-4"
          classNamePrefix="select"
          menuPlacement="auto"
          value={responseSelectOptions.find((option) => option.value === form.response) ?? null}
          onChange={(option: ISelectOption | null) => {
            setForm({
              ...form,
              response: option?.value,
            })
          }}
          isSearchable={false}
        />
      </div>
      <div className="d-flex flex-column align-self-center w-100 mb-1">
        <textarea
          placeholder={t('declaration.p5.notificationDescription')}
          className="w-100 form-control mb-2"
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setForm({
            ...form,
            description: e.target.value,
          })}
        />
      </div>
      <div className="d-flex align-content-end justify-content-end mt-5">
        <button
          type="button"
          className="btn btn-lg btn-primary mx-1 text-secondary shadow-sm"
          disabled={isSubmitting || !form.response}
          onClick={submitForm}
        >
          {
            isSubmitting && <LoadingSpinner />
          }
          {
            !isSubmitting && (<span>{t('buttons.submit')}</span>)
          }
        </button>
      </div>
    </FormModal>
  )
}

export default FinlandCustomsRequestReplyModal
